import { render, staticRenderFns } from "./SendEgiftPanelRecipientsManually.vue?vue&type=template&id=67466756&scoped=true"
import script from "./SendEgiftPanelRecipientsManually.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelRecipientsManually.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelRecipientsManually.vue?vue&type=style&index=0&id=67466756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67466756",
  null
  
)

export default component.exports